// import pageRoutes from "../../../../../libs/constant/pageRoutes";

export default {
    name: 'OrgOverview',
    props: {
        stripeAccountDetails: {
            type: Object,
            default: () => {}
        }
    },
}